module.exports = __webpack_public_path__ + "img/RTB-Silo-front.3861a6b5.png";